<div id="order" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="row" fxLayoutAlign="space-between center">

            <!-- APP TITLE -->
            <div fxLayout="row" fxLayoutAlign="start center">

                <button mat-icon-button class="mr-16" [routerLink]="'/orders'">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <div fxLayout="column" fxLayoutAlign="start start">
                    <div class="h2" *ngIf="cardStats">
                        {{ 'Details'|translate }} {{cardStats.deviceName}}
                    </div>
                    <div class="subtitle secondary-text">
<!--                        <span *ngIf="order.customer">{{order.customer.firstName}} {{order.customer.lastName}}</span>-->
                    </div>
                </div>
            </div>
            <!-- / APP TITLE -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">

            <!-- CONTENT -->
            <div class="content">

                <mat-tab-group fxLayout="column" fxFlex>

                    <mat-tab label="{{'Member Details'|translate}}">

                        <div class="order-details tab-content p-24" fusePerfectScrollbar>

                            <div class="section pb-48">

                                <div class="pb-16" fxLayout="row" fxLayoutAlign="start center">
                                    <mat-icon class="m-0 mr-16 secondary-text">account_circle</mat-icon>
                                    <div class="h2 secondary-text">{{ 'Customer'|translate }}</div>
                                </div>

                                <div class="customer mb-32">
                                    <table class="simple">
                                        <thead>
                                        <tr>
                                            <th>{{ 'Name'|translate }}</th>
                                            <th>{{ 'Age'|translate }}</th>
                                            <th>{{ 'Card'|translate }}</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr *ngIf="cardStats">
                                            <td>
                                                <div fxLayout="row" fxLayoutAlign="start center">
                                                    <span class="name text-truncate">
                                                        {{cardStats.payload.Member.Name}}
                                                    </span>
                                                </div>
                                            </td>
                                            <td>
                                                <span class="email text-truncate">
                                                    {{cardStats.payload.Member.Age}}
                                                </span>
                                            </td>
                                            <td>
                                                <span class="phone text-truncate">
                                                    {{cardStats.payload.Member.BarCode}}
                                                </span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <!--                                <mat-accordion class="addresses">-->

                                <!--                                    <mat-expansion-panel>-->

                                <!--                                        <mat-expansion-panel-header>-->
                                <!--                                            <mat-panel-title>{{ 'Customer Address'|translate }}</mat-panel-title>-->
                                <!--                                        </mat-expansion-panel-header>-->

                                <!--                                        <div fxFlex fxLayout="column">-->
                                <!--                                            <div class="address h4 py-24">{{order.customer.street}}-->
                                <!--                                            </div>-->
                                <!--                                        </div>-->

                                <!--                                    </mat-expansion-panel>-->

                                <!--                                    <mat-expansion-panel>-->

                                <!--                                        <mat-expansion-panel-header>-->
                                <!--                                            <mat-panel-title>{{ 'Invoice Address'|translate }}</mat-panel-title>-->
                                <!--                                        </mat-expansion-panel-header>-->

                                <!--                                        <div fxFlex fxLayout="column">-->
                                <!--                                            <div class="address h4 py-24">{{order.customer.street}}-->
                                <!--                                            </div>-->
                                <!--                                        </div>-->

                                <!--                                    </mat-expansion-panel>-->

                                <!--                                </mat-accordion>-->

                            </div>

                            <div class="section pb-48">

                            </div>
                        </div>
                    </mat-tab>

                    <mat-tab label="{{'Products'|translate}}">
                        <div class="products tab-content p-24" fusePerfectScrollbar>
                            <table class="simple">
                                <thead>
                                <tr>
                                    <th>{{'Name'|translate}}</th>
                                    <th class="w-120">{{ 'Price'|translate }}</th>
                                    <th class="w-80">{{ 'Quantity'|translate }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr class="product-row">
                                    <td>
<!--                                        {{product.voucherTemplate.name}}-->
                                    </td>
                                    <td>
<!--                                        {{product.priceGross}}-->
                                    </td>
                                    <td>
<!--                                        {{product.quantity}}-->
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-tab>

                    <mat-tab label="{{'Invoice'|translate}}">

                        <div class="invoice tab-content p-24" fusePerfectScrollbar>

                            <div id="invoice" class="compact page-layout blank" fxLayout="row" fusePerfectScrollbar>

                                <div class="invoice-container">

                                    <!-- INVOICE -->
                                    <div class="card">

                                        <div class="header">
                                            <div class="invoice-date">{{'Created at'|translate}} {{cardStats.createdAt| date:'dd.MM.yyyy H:mm:ss':'UTC'}}</div>

                                            <div fxLayout="row" fxLayoutAlign="space-between stretch">
                                                <div class="client">
                                                    <div class="invoice-number" fxLayout="row"
                                                         fxLayoutAlign="start center">
                                                        <span class="title">{{ 'INVOICE'|translate }}</span>
                                                        <span class="number"></span>
                                                    </div>

                                                    <div class="info">
                                                        <div class="title">
                                                        </div>
                                                        <div class="address">
                                                        </div>
                                                        <div class="phone"></div>
                                                        <div class="email"></div>
                                                    </div>
                                                </div>

                                                <div class="issuer accent" fxLayout="row" fxLayoutAlign="start center">
                                                    <!--                                                    <div class="logo">-->
                                                    <!--                                                        <img src="assets/images/logos/fuse.svg">-->
                                                    <!--                                                    </div>-->

                                                    <div class="info">
                                                        <div class="title"></div>
                                                        <div class="title">

                                                        </div>
                                                        <div class="title"></div>
                                                        <!--                                                        <div class="title">FUSE INC.</div>-->
                                                        <!--                                                        <div class="address">2810 Country Club Road Cranford, NJ 07016-->
                                                        <!--                                                        </div>-->
                                                        <!--                                                        <div class="phone">+66 123 455 87</div>-->
                                                        <!--                                                        <div class="email">hello@fuseinc.com</div>-->
                                                        <!--                                                        <div class="website">www.fuseinc.com</div>-->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="content">

                                            <table class="simple invoice-table">
                                                <thead>
                                                <tr>
                                                    <th>{{'PRODUCT'|translate}}</th>
                                                    <th class="text-right">{{'PRICE'|translate}}</th>
                                                    <th class="text-right">{{'QUANTITY'|translate}}</th>
                                                    <th class="text-right">{{'TOTAL'|translate}}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr >
                                                    <td>
                                                        <div class="title">

                                                        </div>
                                                    </td>
                                                    <td class="text-right">

                                                    </td>
                                                    <td class="text-right">

                                                    </td>
                                                    <td class="text-right">

                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                        </div>

                                        <div class="footer">
                                            <div class="note">
                                                <!--                                                Please pay within 15 days. Thank you for your business.-->
                                            </div>
                                            <div fxLayout="row" fxLayoutAlign="start start">
                                                <div class="logo">
                                                    <!--                                                    <img src="assets/images/logos/fuse.svg">-->
                                                </div>
                                                <div class="small-note">
                                                    <!--                                                    In condimentum malesuada efficitur. Mauris volutpat placerat auctor.-->
                                                    <!--                                                    Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum.-->
                                                    <!--                                                    Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo-->
                                                    <!--                                                    commodo, a suscipit tellus dapibus. Etiam at felis volutpat est-->
                                                    <!--                                                    mollis lacinia. Mauris placerat sem sit amet velit mollis, in-->
                                                    <!--                                                    porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et-->
                                                    <!--                                                    eget eros.-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- / INVOICE -->

                                </div>
                            </div>
                        </div>
                    </mat-tab>

                </mat-tab-group>

            </div>
            <!-- / CONTENT -->

        </div>
        <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->
</div>


